import axios from 'axios';
import { SystemConfigModel } from '../../pages/administracion/system_config/models/SystemConfigModel';

const API_URL = process.env.REACT_APP_API;

export async function obtenerConfiguracionesService(): Promise<SystemConfigModel[]> {
  try {
    const response = await axios.get(`${API_URL}systemConfig`);
    return response.data.doc.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function actualizarConfiguracionService(id: number, config_value: string | null): Promise<void> {
  try {
    await axios.put(`${API_URL}systemConfig/${id}`, { config_value });
  } catch (error) {
    console.error(error);
    throw error;
  }
}
